import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  // NOTE: localStorage token is per agreed JWT/Bearer architecture; see AuthContext.
  const token = localStorage.getItem("trent_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("trent_token");
      const path = window.location.pathname;
      // Only force redirect when on an authenticated route. Public routes
      // (landing, login, register, pricing) handle their own state.
      const onAuthedRoute =
        path.startsWith("/admin-dashboard") ||
        path.startsWith("/customer-dashboard");
      if (onAuthedRoute) {
        // Bounce admin paths to /admin-login, customer paths to /login.
        window.location.href = path.startsWith("/admin-dashboard")
          ? "/admin-login"
          : "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export default client;
